export default "__VITE_ASSET__567d952a__"